<div class="grid-6 copo-container footer-margin" *ngIf="segment && segment.hardnessList && this.segment.hardnessList.length > 0">
	<div class="grid-column-one-full">
		<mat-expansion-panel [expanded]="true" class="card-info-block">
			<mat-expansion-panel-header>
				<mat-panel-title class="card-content-title">
					<span translate>aqdb.mechanical.characteristics.hardness</span>
				</mat-panel-title>
			</mat-expansion-panel-header>
			<mat-divider class="margin-expansion-panel"></mat-divider>
			<div class="card-content-block triple-column" *ngFor="let hardness of segment.hardnessList">
				<div class="card-contents-infos">
					<div class="card-content-info">
						<div class="card-content-label" translate>aqdb.test.number.hardness</div>
						<div class="card-content-value">{{ hardness.testNumber ? (hardness.testNumber | copoNumber:'number') : UNDERSCORE }}</div>
					</div>
					<div class="card-content-info">
						<div class="card-content-label" translate>aqdb.pos.across.width</div>
						<div class="card-content-value"> 
							<div *ngIf="hardness.samplePositionAcrossWidthCode === 'A'">
								<span translate>aqdb.axis</span>
							</div>
							<div *ngIf="hardness.samplePositionAcrossWidthCode === 'Q'">
								<span translate>aqdb.quarter</span>
							</div>
							<div *ngIf="hardness.samplePositionAcrossWidthCode !== 'A' && hardness.samplePositionAcrossWidthCode !== 'Q'">
								{{ UNDERSCORE }}
							</div>
						</div>
					</div>
				</div>
				<div class="card-contents-infos">
					<div class="card-content-info">
						<div class="card-content-label" translate>aqdb.pos.across.length</div>
						<div class="card-content-value">{{ hardness.samplePositionAlongLength !== null && hardness.samplePositionAlongLength !== undefined ? (hardness.samplePositionAlongLength | copoNumber:'weight') : UNDERSCORE }} </div>
					</div>
					<div class="card-content-info">
						<div class="card-content-label" translate>aqdb.hardness.type</div>
						<div class="card-content-value">{{ hardness.hardnessType ? hardness.hardnessType : UNDERSCORE }}</div>
					</div>
				</div>
				<div class="card-content-info">
					<div class="card-content-label" translate>aqdb.hardness.index</div>
					<div class="card-content-value">{{ hardness.hardnessValue !== null && hardness.hardnessValue !== undefined && isDisplayedData(hardness.indTrsHardness) ? (hardness.hardnessValue | copoNumber:'weight') : UNDERSCORE }}
						<span *ngIf="isTransmittedOnCertificateData(hardness.indTrsHardness)" class="transmitted-data-icon"><mat-icon [matTooltip]="'aqdb.datas.transmitted.on.certificate' | translate" color="accent" class="batch-icon" svgIcon="icon-transmitted"></mat-icon></span>
						<span *ngIf="isMeasuredData(hardness.indTrsHardness, hardness.hardnessValueTypdon)"><mat-icon [matTooltip]="'aqdb.measured.datas' | translate" color="accent" class="batch-icon" svgIcon="icon-measured"></mat-icon></span>
						<span *ngIf="isModelledData(hardness.indTrsHardness, hardness.hardnessValueTypdon)"><mat-icon  [matTooltip]="'aqdb.modelled.data' | translate" color="accent" class="batch-icon" svgIcon="icon-modelled"></mat-icon></span>
					</div>
				</div>
			</div>
		</mat-expansion-panel>
	</div>
</div>
